// La fecha de ingreso del maestro de empleados viene como texto libre: se ha
// guardado en `YYYY-MM-DD`, `DD/MM/YYYY` o ISO según quién la capturó. Estas
// funciones la normalizan para poder mostrarla y editarla con seguridad.
// Cuando el maestro se migre (Parte 2 del módulo) seguirá sirviendo: leer un
// Date de Mongo es el primer caso de `parseFechaIngreso`.

export const parseFechaIngreso = (valor) => {
  if (!valor) return null;

  if (valor instanceof Date) {
    return Number.isNaN(valor.getTime()) ? null : valor;
  }

  const texto = String(valor).trim();
  if (!texto) return null;

  let iso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
  }

  let dmy = texto.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
  if (dmy) {
    return new Date(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1]));
  }

  const fallback = new Date(texto);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
};

// Formato que espera <Input type="date">: siempre YYYY-MM-DD.
export const aFechaInput = (valor) => {
  const fecha = parseFechaIngreso(valor);
  if (!fecha) return '';
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  const dia = String(fecha.getDate()).padStart(2, '0');
  return `${fecha.getFullYear()}-${mes}-${dia}`;
};

export const formatearFecha = (fecha) =>
  fecha
    ? fecha.toLocaleDateString('es-CO', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
    : '—';